import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { columnasFijas } from "./columns";
type Entity = models.StatusCajaRutaViewDto;
export interface Props {
    value: Entity[];
    onRefrescar?: () =>  void;
}


/*
* Listado de StatusCajaRutaViewDto
*/
class StatusCajaRutaViewDtoListNoRx extends React.PureComponent<Props> {
    render() {
        return (
            <div>
                <kea.Grid2 items={this.props.value} columnas={columnasFijas} />
            </div>
        );
    }
}

/**Muestra un listado de los status de caja */
export const StatusCajaRutaViewDtoListMem = componentToRx(StatusCajaRutaViewDtoListNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/movimientoscajaruta/list/listmem.tsx